import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListSalesPromotionsAction = "LIST_SALES_PROMOTIONS";
const Waiting = "WAITNG_SALES_PROMOTIONS";

const initialState = {
    list: [],
    nowWainting: false
};
export const actionCreators = {
    /**
     * 販促物一覧を取得します。
     */
    listSalesPromotions: (token) => async (dispatch) => {
        const routeurl = `api/user/salesPromotions/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const list = await response.json();
                dispatch({ type: ListSalesPromotionsAction, list });
                return list;
            } else {
                throw new Error('販促物一覧取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListSalesPromotionsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    return state;
}